import React from 'react'

import styles from './styles.module.scss'

const DataNotAvailableText = () => (
  <span className={styles.disabledText}>Data not available</span>
)

export default DataNotAvailableText
